import React from 'react'
import { browserHistory } from 'react-router'
import update from 'immutability-helper';
import { phoneNumberFormatter } from '../../../helpers/General/PhoneNunberFormatter'

import { modal } from '../../../core/utilities/modal'
import { adminUserAccounts } from '../../../core/controllers/Admin/AdminUserAccounts'

export default class AdminUserEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userAccountID : props.userAccountID,
            sortID: null,
            userAccountData: {
                'user': {
                    'user_type_alias': 'property-manager',
                    'username': '',
                    'password': ''
                },
                'user_data': {
                    'email': '',
                    'firstname': '',
                    'lastname': '',
                    'phone': '',
                    'company': '',
                    qb_vendor_name_ref: null,
                    qb_vendor_account_ref: null
                },
                company: {
                    can_process_payments: 0
                }
            }
        };
    }

    componentDidMount() {
        var self = this;
        if(!this.props.newUserAccount) {
            adminUserAccounts.getUser(this.state.userAccountID,function(response) {
                self.setState({
                    userAccountData: response.data
                })
            });
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.userAccountData.user_type_alias === undefined || nextState.userAccountData.user_type_alias == "") {
            nextState.userAccountData.user_type_alias = "property-manager";
        }
    }

    handleUsernameChange(e) {
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user: {
                    username: {
                        $set: e.target.value
                    }
                }
            })
        });
    }

    handleEmailChange(e) {
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {
                    email: {
                        $set: e.target.value
                    },
                    username: {
                        $set: e.target.value
                    }
                }
            })
        });
    }

    handleAccountTypeSelect(e) {
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user: {user_type_alias: {$set: e.target.value
                }}}
            )
        });
    }

    handlePasswordChange(e) {
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user: {password: {$set: e.target.value
                }}}
            )
        });
    }

    handleFirstnameChange(e){
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {firstname: {$set: e.target.value
                }}}
            )
        });
    }

    handleLastnameChange(e){
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {lastname: {$set: e.target.value
                }}}
            )
        });
    }

    handleCompanyChange(e){
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {company: {$set: e.target.value
                }}}
            )
        });
    }

    handleQbVendorRefChange(e){
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {qb_vendor_name_ref: {$set: e.target.value
                }}}
            )
        });
    }

    handleQbVendorAccountRefChange(e){
        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {qb_vendor_account_ref: {$set: e.target.value
                }}}
            )
        });
    }

    handlePhoneChange(e){
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            userAccountData: update(this.state.userAccountData, {
                user_data: {phone: {$set: phoneNumber
                }}}
            )
        });
    }

    updateUserAccount(e) {
        if(!this.validateData()){
            return;
        }
        adminUserAccounts.updateUser(this.state.userAccountData, function(response) {
            modal.showInfo("User account has been updated.", "success", "top", "center");
        });
    }

    deleteUserAccount(e) {
        adminUserAccounts.deleteUser(this.state.userAccountID);
    }

    saveUserAccount(e) {
        var self = this;
        if(!this.validateData()){
            return;
        }
        adminUserAccounts.saveNewUser(this.state.userAccountData, function(response) {
            if (response.status && response.status == 'OK') {
                if (self.props.newUserAccount) {
                    modal.showInfo("User account has been created.", "success", "top", "center");
                    self.setState({
                        userAccountData: {
                            'user': {
                                'user_type_alias': 'property-manager',
                                'username': '',
                                'password': ''
                            },
                            'user_data': {
                                'email': '',
                                'firstname': '',
                                'lastname': '',
                                'phone': '',
                                'company': '',
                                qb_vendor_name_ref: null,
                                qb_vendor_account_ref: null
                            },
                            company: {
                                can_process_payments: 0
                            }
                        }
                    })
                }
            }
        });
    }

    activatePayments() {
        var self = this;
        const id = this.state.userAccountData.user.id;
        adminUserAccounts.activatePaymentCollection(id, function(response) {
            modal.showInfo("User can now process payments from tenants.", "success", "top", "center");
            adminUserAccounts.getUser(id,function(response) {
                self.setState({
                    userAccountData: response.data
                })
            });
        });
    }

    disablePayments() {
        var self = this;
        const id = this.state.userAccountData.user.id;
        adminUserAccounts.disablePaymentCollection(id, function(response) {
            modal.showInfo("User can no longer process rent payments from tenants.  Tenants can not pay any longer.", "warning", "top", "center");
            adminUserAccounts.getUser(id,function(response) {
                self.setState({
                    userAccountData: response.data
                })
            });
        });
    }

    validateData() {
        const enteredData = this.state.userAccountData;
        const email = enteredData.user_data.email;
        const username = enteredData.user.username;
        const password = enteredData.user.password;

        if(email.length == 0) {
            modal.showInfo("You need to enter an email address.", "danger", "top", "center");
            return false;
        }

        // validate email
        const lastAtPos = email.lastIndexOf('@');
        const lastDotPos = email.lastIndexOf('.');
        if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
            modal.showInfo("Email is invalid.", "danger", "top", "center");
            return false;
        }

        if (this.state.newUserAccount) {
            //new account conditions
        }

        return true;
    }

    render(){
        const newUserAccount = this.props.newUserAccount;
        const userAccountData = this.state.userAccountData;
        const company = userAccountData.company;

        var buttonText = 'Update Manager';
        var userFunc = this.updateUserAccount.bind(this);
        if (newUserAccount) {
            buttonText = 'Create Manager';
            userFunc = this.saveUserAccount.bind(this);
        }

        return (
        <div>
        <div class="row blue-bottom-margin">
            {newUserAccount ? (
            <div class="row">
                <div class="sub-page-header-row col-md-11">
                    <div class="row">
                        <span class="sub-page-header-title">Add a Manager</span>
                    </div>
                </div>
            </div>
            ) : (
            <div class="row">
                <div class="sub-page-header-row col-md-11">
                    <div class="row">
                        <span class="sub-page-header-title">{userAccountData.user_data.firstname} {userAccountData.user_data.lastname}</span>
                    </div>
                </div>
            </div>
            )}
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Manager Information</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <form>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="text" class="form-control tenant-info" name="email" placeholder="Email" id="email" value={userAccountData.user_data.email} onChange={this.handleEmailChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Firstname</label>
                                        <input type="text" class="form-control tenant-info" value={userAccountData.user_data.firstname} name="firstname" placeholder="Firstname" id="firstname" onChange={this.handleFirstnameChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Lastname</label>
                                        <input type="text" class="form-control tenant-info" name="lastname" placeholder="Lastname" id="lastname" value={userAccountData.user_data.lastname} onChange={this.handleLastnameChange.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                            {/* <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label for="useraccounttype">User Account Type</label>
                                        <div class="clearfix"></div>
                                        <UserAccountTypeSelect columnSize={6} title="" sortID={userAccountData.user.user_type_alias} onChange={this.handleAccountTypeSelect.bind(this)}/>
                                    </div>
                                </div>
                            </div> */}
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Company</label>
                                        <input type="text" class="form-control tenant-info" name="company" placeholder="Company" id="company" value={userAccountData.user_data.company} onChange={this.handleCompanyChange.bind(this)}/>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Phone</label>
                                        <input type="text" class="form-control tenant-info" name="phone" placeholder="Phone Number" id="phone" value={userAccountData.user_data.phone} onChange={this.handlePhoneChange.bind(this)}/>
                                    </div>
                                </div>
                                { userAccountData.user.user_type_alias == 'contractor' && (
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>QuickBooks Vendor ID (Optional)</label>
                                        <input type="text" class="form-control tenant-info" name="qbvendorid" placeholder="Johns Construction" id="qbvendorid" value={userAccountData.user_data.qb_vendor_name_ref} onChange={this.handleQbVendorRefChange.bind(this)}/>
                                    </div>
                                </div>
                                )}
                                { userAccountData.user.user_type_alias == 'contractor' && (
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>QuickBooks Vendor Account ID (Optional)</label>
                                        <input type="text" class="form-control tenant-info" name="qbvendoraccountid" placeholder="Expense" id="qbvendoraccountid" value={userAccountData.user_data.qb_vendor_account_ref} onChange={this.handleQbVendorAccountRefChange.bind(this)}/>
                                    </div>
                                </div>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row blue-bottom">
            <div class="blue-bottom-center-align">
                { newUserAccount === false ? (
                    <div>
                        <div class="col-md-3 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteUserAccount.bind(this)}>
                            Delete Manager
                            </button>
                        </div>
                        <div class="col-md-2 col-md-offset-1 col-sm-6 col-xs-12">
                            <button type="button" id="save-user" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.updateUserAccount.bind(this)}>
                            {buttonText}
                            </button>
                        </div>
                        { userAccountData.user.user_level == 0 && (
                            company.can_process_payments == 0 ? (
                            <div class="col-md-4">
                                <button type="button" id="generate-pdf" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.activatePayments.bind(this)}>
                                Activate Payment Collection
                                </button>
                            </div>
                            ) : (
                            <div class="col-md-4">
                                <button type="button" id="generate-pdf" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.disablePayments.bind(this)}>
                                Disable Payment Collection
                                </button>
                            </div>
                            )
                        )}
                    </div>
                ) : (
                    <div class="col-md-12">
                        <button type="button" id="create-user" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={userFunc}>
                        {buttonText}
                        </button>
                    </div>
                )}
                <div class="clearfix"></div>
            </div>
        </div>
        </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/User/AdminUserEdit.jsx